import { NgModule } from '@angular/core';
import { AspectMenuBuilder } from './aspect-menu-builder';
import { ClientMenuBuilder } from './client-menu-builder';
import { ContentMenuBuilder } from './content-menu-builder';
import { ImportMenuBuilder } from './import-menu-builder';
import { RoleMenuBuilder } from './role-menu-builder';
import { TypeMenuBuilder } from './type-menu-builder';
import { UserMenuBuilder } from './user-menu-builder';

@NgModule({
    declarations: [
    ],
    exports: [
    ],
    providers: [
        AspectMenuBuilder,
        ClientMenuBuilder,
        ContentMenuBuilder,
        ImportMenuBuilder,
        RoleMenuBuilder,
        TypeMenuBuilder,
        UserMenuBuilder
    ]
})
export class MenuModule { }

export * from './menu-data';
export * from './base-menu';
export * from './menu-builder';
export * from './aspect-menu-builder';
export * from './client-menu-builder';
export * from './content-menu-builder';
export * from './import-menu-builder';
export * from './role-menu-builder';
export * from './type-menu-builder';
export * from './user-menu-builder';
